/* eslint-disable */
import { Cardigan } from 'cardigan-js';

window.Cardigan = new Cardigan(document, window.Shopify, {
  endpoint: 'https://app.runcardigan.com/api/v1',
  subdomain: window.TMW.subDomain,
});
